module.exports = __webpack_public_path__ + "img/qkc.7391b736.svg";